export type feedbackListType = {
    task: any;
    milestoneTask: string;
  };

  export const selectedFeedbackStatusFilterOptions = [
    { value: "Incomplete", label: "Incomplete Tasks" },
    { value: "Completed", label: "Completed Tasks" },
    { value: "All", label: "All Tasks" },
  ];